import { ReactNode, useContext, useMemo } from 'react'
import { DashboardContext } from '../../context'
import ErrorBoundary from '../error/ErrorBoundary'
import { Route, Routes } from 'react-router-dom'
import Error404 from '../error/Error404'
import { ItemRouter } from '../../types'
import LinksCardContainer from './LinkCardContainer'

interface RouterContainerProps {
    items: ItemRouter[],
    home?: ReactNode
}

export default function RouterBase({ items, home }: Readonly<RouterContainerProps>) {
    const dashboardContext = useContext(DashboardContext)
    const avaibleItems = useMemo<ItemRouter[]>(() => {
        let avaiblesLinks = dashboardContext?.appData?.paths || []
        return items.filter(m => !!avaiblesLinks.find(u => u === m.fullPath))
    }, [dashboardContext?.appData.paths])
    return (
        <ErrorBoundary>
            <Routes>
                {avaibleItems.map(i => <Route key={i.fullPath} path={getPath(i)} element={i.component} />)}
                <Route path='/' element={home || (dashboardContext?.navBar.menuSelected ? <LinksCardContainer menu={dashboardContext?.navBar.menuSelected} /> : <Error404 />)} />
                <Route path='*' element={<Error404 />} />
            </Routes>
        </ErrorBoundary>
    )
}

function getPath(item: ItemRouter) {
    if (item.path) {
        return `${item.path}${item.nestedRouter ? '/*' : ''}`
    }
    let fragment = item.fullPath.split('/')
    return `/${fragment[fragment.length - 1]}${item.nestedRouter ? '/*' : ''}`
}
